export const getError = state => state.weatherModal.get('error')
export const getIsSubmitting = state => state.weatherModal.get('isSubmitting')
